import Layout from '../components/MyLayout.js';
import fetch from 'isomorphic-unfetch';
import { post } from 'axios';
import React from 'react';
import imageTools from '../utils/imagetools';
import apiBase from '../utils/apiBase';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import css from '../sass/sitestyle.scss';

/* TODO:
- get radio button sending working
- convert uploaded data to redis format
- save to redis

*/

const resizeImage = (file, size) => {
  const maxDimensions = {
    width: size,
    height: size,
  };
  return new Promise((resolve, reject) => {
    imageTools.resize(file, maxDimensions, function(result) {
      return resolve(result);
    });
  });
};
const fileUpload = (burgerIcon, burgerImage, state) => {
  const url = `${apiBase}/upload`;
  const formData = new FormData();
  formData.set('icon', burgerIcon);
  formData.set('image', burgerImage);
  formData.set('restaurantName', state.restaurantName);
  formData.set('burgerName', state.burgerName);
  formData.set('burgerNotes', state.burgerNotes || '');
  formData.set('dateEaten', new Date(state.dateEaten).getTime() / 1000);
  formData.set('meatFlavour', state.meatFlavour);
  formData.set('meatTexture', state.meatTexture);
  formData.set('meatSucculence', state.meatSucculence);
  formData.set('meatVolume', state.meatVolume);
  formData.set('bunRating', state.bunRating);
  formData.set('toppingRating', state.toppingRating);
  formData.set('sideRating', state.sideRating);
  formData.set('lat', state.lat);
  formData.set('long', state.long);
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
    withCredentials: true,
  };
  return post(url, formData, config);
};

const getTopBurgers = async () => {
  let topBurgers = await fetch(`${apiBase}/top/10`);
  topBurgers = await topBurgers.json();
  return topBurgers;
};

export default class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      dateEaten: moment(),
      authChecked: false,
      error: '',
      submitting: false,
    };
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
    this.onChangeRadio = this.onChangeRadio.bind(this);
    this.getPosition = this.getPosition.bind(this);
    this.getRadioGroup = this.getRadioGroup.bind(this);
  }
  static async getInitialProps({ query }) {
    const topBurgers = await getTopBurgers();
    return {
      topBurgers,
    };
  }

  getRadioGroup(label, name) {
    const radioRows = [];

    for (let i = 1; i <= 10; i++) {
      radioRows.push(
        <label key={name + i} htmlFor={name + i}>
          <input
            type="radio"
            id={name + i}
            label={i}
            name={name}
            value={i}
            onChange={this.onChangeRadio}
          />
          {i}
        </label>
      );
    }
    const radioGroup = [];
    radioGroup.push(
      <fieldset className={css['rating-field']}>
        <legend>{label}</legend>
        <div className={css['rating-options']}>{radioRows}</div>
      </fieldset>
    );
    return radioGroup;
  }

  onFileChange(e) {
    this.setState({ file: e.target.files[0] });
  }

  onChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onChangeRadio(event) {
    console.log(event.target);
    this.setState({ [event.target.name]: event.target.value });
  }

  onChangeDate(date) {
    this.setState({ dateEaten: date });
  }

  async onFormSubmit(e) {
    e.preventDefault(); // Stop form submit
    if (!this.state.file) {
      return this.setState({ error: 'Choose a burger photo first.' });
    }
    this.setState({ submitting: true, error: '' });
    try {
      const burgerIcon = await resizeImage(this.state.file, 256);
      const burgerImage = await resizeImage(this.state.file, 1500);
      await fileUpload(burgerIcon, burgerImage, this.state);
      window.location.assign('/');
    } catch (err) {
      if (err.response && err.response.status === 401) {
        return window.location.assign('/login');
      }
      const message =
        err.response && err.response.data && err.response.data.err
          ? err.response.data.err
          : 'The burger could not be uploaded.';
      this.setState({ error: message, submitting: false });
    }
  }

  getPosition(position) {
    console.log(typeof position.coords.latitude);
    this.setState({ lat: position.coords.latitude });
    this.setState({ long: position.coords.longitude });
  }

  async componentDidMount() {
    try {
      const response = await fetch(`${apiBase}/session`, { credentials: 'include' });
      if (!response.ok) return window.location.assign('/login');
      this.setState({ authChecked: true });
    } catch (err) {
      return window.location.assign('/login');
    }
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.getPosition, (err) =>
        console.log(err)
      );
    }
  }

  render() {
    if (!this.state.authChecked) return <Layout {...this.props}><div className={css.loading}>Checking login…</div></Layout>;
    return (
      <Layout {...this.props}>
        <div className={css['submit-page']}>
          <div className={css['page-heading']}>
            <p className={css.eyebrow}>Add a review</p>
            <h1>Rate your burger</h1>
            <p>Upload the evidence, score every bite, and give it a place on the board.</p>
          </div>
          <form className={css['burger-form']} onSubmit={this.onFormSubmit}>
            {this.state.error ? <p className={css.alert} role="alert">{this.state.error}</p> : null}
            <section className={css['form-section']}>
              <h2>The essentials</h2>
              <label htmlFor="burgerPhoto">Burger photo</label>
              <input id="burgerPhoto" type="file" accept="image/*" name="burgerPhoto" onChange={this.onFileChange} />
              <div className={css['form-grid']}>
                <div><label htmlFor="dateEaten">Date eaten</label>
                <DatePicker name="dateEaten" selected={this.state.dateEaten} onChange={this.onChangeDate} /></div>
                <div><label htmlFor="restaurantName">Restaurant</label>
                <input id="restaurantName" type="text" name="restaurantName" required value={this.state.restaurantName || ''} onChange={this.onChange} /></div>
                <div><label htmlFor="burgerName">Burger name</label>
                <input id="burgerName" type="text" name="burgerName" required value={this.state.burgerName || ''} onChange={this.onChange} /></div>
              </div>
            </section>
          <input
            id="lat"
            type="hidden"
            name="lat"
            value={this.state.lat || ''}
            onChange={this.onChange}
          />
          <input
            id="long"
            type="hidden"
            name="long"
            value={this.state.long || ''}
            onChange={this.onChange}
          />
            <section className={css['form-section']}>
              <h2>Tasting notes</h2>
              <label htmlFor="burgerNotes">What made it memorable?</label>
              <textarea id="burgerNotes" rows="5"
            name="burgerNotes"
            value={this.state.burgerNotes || ''}
            onChange={this.onChange}
              />
            </section>
            <section className={css['form-section']}>
              <h2>Score it out of 10</h2>
              <div className={css['ratings-grid']}>
            {this.getRadioGroup('Meat Flavour', 'meatFlavour')}
            {this.getRadioGroup('Meat Texture', 'meatTexture')}
            {this.getRadioGroup('Meat Succulence', 'meatSucculence')}
            {this.getRadioGroup('Meat Ratio', 'meatVolume')}
            {this.getRadioGroup('Bun Rating', 'bunRating')}
            {this.getRadioGroup('Topping Rating', 'toppingRating')}
            {this.getRadioGroup('Side Rating', 'sideRating')}
              </div>
            </section>
          <button className={css['primary-button']} type="submit" disabled={this.state.submitting}>
            {this.state.submitting ? 'Uploading…' : 'Upload'}
          </button>
        </form>
        </div>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// pages/submit.js